// src/app/core/signalr/studyExportHubClient.ts
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import getApiAccessToken from '@core/utils/getApiAccessToken';
import getProductAccessToken from '@core/utils/getProductAccessToken';
import { ExportStatusPayload } from './types';

const HUB_PATH = '/hubs/study-export';
const METHOD_NAME = 'exportStatusChanged';
const ORG_HEADER = 'Organization-Authorization';

export const createStudyExportConnection = async (): Promise<HubConnection> => {
  const productAccessToken = (await getProductAccessToken()) ?? '';
  const headers: Record<string, string> =
    productAccessToken.length > 0 ? { [ORG_HEADER]: `Bearer ${productAccessToken}` } : {};

  return new HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_BASE_API_URL ?? ''}${HUB_PATH}`, {
      accessTokenFactory: async () => (await getApiAccessToken()) ?? '',
      headers,
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
};

export const joinStudyExport = (conn: HubConnection, studyInstanceUid: string) =>
  conn.invoke('JoinStudyExport', studyInstanceUid);

export const leaveStudyExport = async (
  conn: HubConnection,
  studyInstanceUid: string,
): Promise<void> => {
  try {
    await conn.invoke('LeaveStudyExport', studyInstanceUid);
  } catch {
    /* fire-and-forget */
  }
};

export const onExportStatusChanged = (
  conn: HubConnection,
  handler: (payload: ExportStatusPayload) => void,
): (() => void) => {
  conn.on(METHOD_NAME, handler);
  return () => conn.off(METHOD_NAME, handler);
};
